import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import * as React from "react";
import Panel from "../Panel";
import SlideTransition from "../SlideTransition";
import PopoverArrow from "./PopoverArrow";

function getSlideDirection(placement) {
  if (placement == null || placement.includes("bottom")) return "down";
  if (placement.includes("top")) return "up";
  if (placement.includes("right")) return "right";
  if (placement.includes("left")) return "left";
  return "down";
}

function PopoverPanel(_ref) {
  var isOpen = _ref.isOpen,
      placement = _ref.placement,
      innerRef = _ref.innerRef,
      arrowProps = _ref.arrowProps,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["isOpen", "placement", "innerRef", "arrowProps", "children"]);

  return ___EmotionJSX(SlideTransition, {
    in: isOpen,
    direction: getSlideDirection(placement)
  }, ___EmotionJSX(Panel, _extends({
    ref: innerRef,
    display: "inline-flex",
    elevation: 10,
    padding: 0,
    zIndex: "popover"
  }, props), children, ___EmotionJSX(PopoverArrow, _extends({}, arrowProps, {
    placement: placement
  }))));
}

export default React.forwardRef(function (props, ref) {
  return ___EmotionJSX(PopoverPanel, _extends({
    innerRef: ref
  }, props));
});